// src/components/dashboard/QuickStats.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Calendar, Award } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface QuickStatsProps {
  weeklyTests: number;
  monthlyTests: number;
  teamSize: number;
  rank: number;
}

export const QuickStats: React.FC<QuickStatsProps> = ({
  weeklyTests,
  monthlyTests,
  teamSize,
  rank,
}) => {
  const stats = [
    {
      title: 'This Week',
      value: weeklyTests,
      icon: Calendar,
      color: 'text-purple-500',
      bgColor: 'from-purple-500/10 to-pink-500/10',
      borderColor: 'border-purple-500/50',
    },
    {
      title: 'This Month',
      value: monthlyTests,
      icon: TrendingUp,
      color: 'text-green-500',
      bgColor: 'from-green-500/10 to-emerald-500/10',
      borderColor: 'border-green-500/50',
    },
    {
      title: 'Team Rank',
      value: `#${rank}`,
      icon: Award,
      color: 'text-amber-500',
      bgColor: 'from-amber-500/10 to-yellow-500/10',
      borderColor: 'border-amber-500/50',
    },
    {
      title: 'Active Users',
      value: teamSize,
      icon: Users,
      color: 'text-cyan-500',
      bgColor: 'from-cyan-500/10 to-blue-500/10',
      borderColor: 'border-cyan-500/50',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.title}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: index * 0.1 }}
        >
          <Card className={`border-2 ${stat.borderColor} bg-gradient-to-br ${stat.bgColor}`}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </CardHeader>
            <CardContent>
              <div className={`text-3xl font-bold ${stat.color}`}>{stat.value}</div>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </div>
  );
};

